import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { blogPosts } from './blogPosts';
import './BlogPage.css';

const BlogPage: React.FC = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const title = 'AI Blog: Image to Video & Face Swap Guides | Glistar.ai';
    document.title = title;

    const metaName = 'description';
    const previousDescription = document.querySelector(`meta[name="${metaName}"]`)?.getAttribute('content') || '';

    let metaDescription = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = metaName;
      document.head.appendChild(metaDescription);
    }
    metaDescription.content =
      'Explore Glistar.ai blog articles on AI image-to-video generation, face swap workflows, marketing ideas, and 2026 tool comparisons.';

    return () => {
      document.title = previousTitle;
      const currentMetaDescription = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
      if (currentMetaDescription) {
        currentMetaDescription.content = previousDescription;
      }
    };
  }, []);

  return (
    <div className="blog-page">
      <Header />

      <main id="main" className="blog-main">
        <div className="blog-container">
          <h1 className="blog-title">Glistar.ai Blog</h1>
          <p className="blog-subtitle">
            English static articles for Image-to-Video and Face Swap workflows.
          </p>

          <div className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.slug} className="blog-card">
                <p className="blog-card-meta">
                  <span>{post.category}</span>
                  <span>{post.publishDate}</span>
                </p>
                <h2>{post.title}</h2>
                <p>{post.description}</p>
                <Link to={`/blog/${post.slug}`} className="blog-card-link">
                  Read article
                </Link>
              </article>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPage;
